module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered",
    class: {
      'direction-rtl': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_c('p', {
    class: {
      'float-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    },
    attrs: {
      "id": "selectPlatformText"
    }
  }, [_vm._v(_vm._s(_vm.$t("choose_your_desired_trading_platform_and_settings").tTitle()))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "accountPlatformContainer",
    class: {
      'selected': _vm.platform == 'mt4', 'float-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    },
    on: {
      "click": function($event) {
        _vm.platform = 'mt4'
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "mt4Logo"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mt4Inputs"
    }
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mt4.currency),
      expression: "mt4.currency"
    }],
    attrs: {
      "id": "mt4Currency"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.mt4, "currency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "selected"
    }
  }, [_vm._v(_vm._s(_vm.$t("select_currency").tTitle()))]), _vm._v(" "), _vm._l((_vm.$getCurrencies()), function(c, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(i) + " (" + _vm._s(c.symbol) + ")")])
  })], 2)]), _vm._v(" "), _c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mt4.group),
      expression: "mt4.group"
    }],
    attrs: {
      "id": "mt4AccountType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.mt4, "group", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "selected"
    }
  }, [_vm._v(_vm._s(_vm.$t("select_account_type").tTitle()))]), _vm._v(" "), _vm._l((_vm.mt4.groupOptions), function(g, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": g.name
      }
    }, [_vm._v(_vm._s(g.display_name) + _vm._s((_vm.mt4.currency == '' ? " (" + g.currency + ")" : "")))])
  })], 2)]), _vm._v(" "), _c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mt4.leverage),
      expression: "mt4.leverage"
    }],
    attrs: {
      "id": "mt4Leverage"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.mt4, "leverage", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "selected"
    }
  }, [_vm._v(_vm._s(_vm.$t("select_leverage").tTitle()))]), _vm._v(" "), _vm._l((_vm.leverages), function(l, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": l.leverage
      }
    }, [_vm._v("1:" + _vm._s(l.leverage))])
  })], 2)]), _vm._v(" "), _c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mt4.balance),
      expression: "mt4.balance"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.mt4, "balance", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "selected"
    }
  }, [_vm._v(_vm._s(_vm.$t("select_starting_balance").tTitle()))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "500"
    }
  }, [_vm._v("500")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1000"
    }
  }, [_vm._v("1,000")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3000"
    }
  }, [_vm._v("3,000")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5000"
    }
  }, [_vm._v("5,000")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20000"
    }
  }, [_vm._v("20,000")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50000"
    }
  }, [_vm._v("50,000")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100000"
    }
  }, [_vm._v("100,000")])])])]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.createTradingAccount('mt4')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("create").tUpper()))])]), _vm._v(" "), _c('div', {
    staticClass: "accountPlatformContainer",
    class: {
      'selected': _vm.platform == 'mt5', 'float-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    },
    on: {
      "click": function($event) {
        _vm.platform = 'mt5'
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "mt5Logo"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mt5Inputs"
    }
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mt5.currency),
      expression: "mt5.currency"
    }],
    attrs: {
      "id": "mt5Currency"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.mt5, "currency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "selected"
    }
  }, [_vm._v(_vm._s(_vm.$t("select_currency").tTitle()))]), _vm._v(" "), _vm._l((_vm.$getCurrencies()), function(c, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(i) + " (" + _vm._s(c.symbol) + ")")])
  })], 2)]), _vm._v(" "), _c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mt5.group),
      expression: "mt5.group"
    }],
    attrs: {
      "id": "mt5AccountType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.mt5, "group", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "selected"
    }
  }, [_vm._v(_vm._s(_vm.$t("select_account_type").tTitle()))]), _vm._v(" "), _vm._l((_vm.mt5.groupOptions), function(g, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": g.name
      }
    }, [_vm._v(_vm._s(g.display_name) + _vm._s((_vm.mt5.currency == '' ? " (" + g.currency + ")" : "")))])
  })], 2)]), _vm._v(" "), _c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mt5.leverage),
      expression: "mt5.leverage"
    }],
    attrs: {
      "id": "mt5Leverage"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.mt5, "leverage", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "selected"
    }
  }, [_vm._v(_vm._s(_vm.$t("select_leverage").tTitle()))]), _vm._v(" "), _vm._l((_vm.leverages), function(l, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": l.leverage
      }
    }, [_vm._v("1:" + _vm._s(l.leverage))])
  })], 2)]), _vm._v(" "), _c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mt5.balance),
      expression: "mt5.balance"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.mt5, "balance", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "selected"
    }
  }, [_vm._v(_vm._s(_vm.$t("select_starting_balance").tTitle()))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "500"
    }
  }, [_vm._v("500")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1000"
    }
  }, [_vm._v("1,000")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3000"
    }
  }, [_vm._v("3,000")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5000"
    }
  }, [_vm._v("5,000")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20000"
    }
  }, [_vm._v("20,000")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50000"
    }
  }, [_vm._v("50,000")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100000"
    }
  }, [_vm._v("100,000")])])])]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.createTradingAccount('mt5')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("create").tUpper()))])]), _vm._v(" "), _c('div', {
    staticClass: "is-clearfix"
  }), _vm._v(" "), _c('error-modal')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2177072c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/TA/CreateDemo.vue
// module id = 728
// module chunks = 0